import { galleries } from '../../data'

const initState = galleries

function reducer(state = initState, action) {
   switch (action.type) {
      default:
         return state
   }
}

export default reducer
